export default __webpack_public_path__ + "static/monitoring_and_audit-07e73952c93e234ea819831eb729fb6c.svg";